import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
// Featured/hero images from local products folder
import imgHOD1 from '../assets/products/1000154716.jpg';
import imgScan1 from '../assets/products/1000215907.jpg';
import imgFeat1 from '../assets/products/1000154639.jpg';
import imgFeat2 from '../assets/products/1000215929.jpg';
import imgFeat3 from '../assets/products/1000154583.jpg';
import imgGallery1 from '../assets/products/1000154511.jpg';
import imgGallery2 from '../assets/products/1000154680.jpg';
import imgGallery3 from '../assets/products/1000154744.jpg';
import imgGallery4 from '../assets/products/1000215923.jpg';
import video2 from '../assets/products/1000213731.mp4';

const Homepage = () => {
  const [selectedBrand, setSelectedBrand] = useState(null);

  const brands = [
    {
      id: 'house-of-deepak',
      title: 'House of Deepak',
      subtitle: 'Indian Wear Collection',
      description: 'Discover our exquisite collection of traditional Indian wear, crafted with passion and attention to detail.',
      link: '/indian-wear',
      image: imgHOD1,
      instagram: 'https://www.instagram.com/houseofdeepak',
      facebook: 'https://www.facebook.com/share/1DKKAZUGu9/',
      email: 'info@houseofdeepak.in',
      gradient: 'from-amber-50 to-orange-50',
      textColor: 'text-amber-900',
      buttonColor: 'bg-amber-800 hover:bg-amber-900'
    },
    {
      id: 'scan-by-deepak-raj',
      title: 'Scan by Deepak Raj',
      subtitle: 'Western Wear Collection',
      description: 'Explore our contemporary western wear collection, blending modern style with timeless elegance.',
      link: '/western-wear',
      image: imgScan1,
      instagram: 'https://www.instagram.com/scan.deepakraj__',
      facebook: 'https://www.facebook.com/share/1DKKAZUGu9/',
      email: 'info@houseofdeepak.in',
      gradient: 'from-slate-50 to-gray-50',
      textColor: 'text-slate-900',
      buttonColor: 'bg-slate-800 hover:bg-slate-900'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "ClothingStore",
    "name": "House of Deepak",
    "description": "Where tradition meets contemporary elegance. Discover our curated collections of Indian and Western wear.",
    "url": "https://houseofdeepak.in",
    "logo": "https://houseofdeepak.in/logo512.png",
    "image": "https://houseofdeepak.in/images/og-image.jpg",
  "telephone": "+91 9167602861",
    "email": "info@houseofdeepak.in",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "IN"
    },
    "sameAs": [
      "https://www.instagram.com/houseofdeepak",
      "https://www.facebook.com/share/1DKKAZUGu9/",
      "https://www.instagram.com/scan.deepakraj__"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Fashion Collections",
      "itemListElement": [
        {
          "@type": "OfferCatalog",
          "name": "Indian Wear",
          "itemListElement": [
            { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Sarees" } },
            { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Lehengas" } },
            { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Kurtas" } }
          ]
        },
        {
          "@type": "OfferCatalog",
          "name": "Western Wear",
          "itemListElement": [
            { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Dresses" } },
            { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Tops" } }
          ]
        }
      ]
    }
  };

  return (
    <>
    <SEO 
      title="Home"
      description="House of Deepak - Where tradition meets contemporary elegance. Discover our curated collections of Indian ethnic wear and Western contemporary fashion. Shop sarees, lehengas, kurtas, dresses, and more."
      keywords="Indian ethnic wear, traditional sarees, designer lehengas, contemporary fashion, western wear, ethnic clothing online, House of Deepak, Scan by Deepak Raj"
      schema={organizationSchema}
    />
    <div className="min-h-screen bg-cream relative overflow-hidden pt-16 md:pt-20 w-full">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>

      {/* Main Content */}
      <div className="relative z-10 min-h-screen flex items-center">
        <div className="w-full section-padding">
          <div className="container-max">
            {/* Header */}
            <motion.div
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-center mb-16"
            >
              {/* <motion.div
                className="flex justify-center mb-8"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: 0.3 }}
              >
                <img
                  src={require('../assets/website_logo.png')}
                  alt="House of Deepak Logo"
                  className="h-24 md:h-32 w-auto"
                />
              </motion.div> */}
              <h1 className="text-5xl md:text-7xl font-serif font-light text-deep-brown mb-6 mt-8 md:mt-12">
                House of Deepak
              </h1>
              <p className="text-xl text-warm-gray max-w-2xl mx-auto leading-relaxed">
                Where tradition meets contemporary elegance. Choose your style journey.
              </p>
            </motion.div>

            {/* Brand Cards */}
            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate="visible"
              className="grid lg:grid-cols-2 gap-6 md:gap-8 max-w-6xl mx-auto w-full"
            >
              {brands.map((brand) => (
                <motion.div
                  key={brand.id}
                  variants={cardVariants}
                  className="group cursor-pointer"
                  onMouseEnter={() => setSelectedBrand(brand.id)}
                  onMouseLeave={() => setSelectedBrand(null)}
                >
                  <div className={`relative h-[500px] md:h-[600px] bg-gradient-to-br ${brand.gradient} rounded-lg overflow-hidden shadow-xl transition-all duration-500 hover:shadow-2xl hover:scale-105 w-full`}>
                    {/* Brand Image as Background */}
                    <div className="absolute inset-0">
                      <img 
                        src={brand.image} 
                        alt={brand.title}
                        className="w-full h-full object-cover opacity-30 group-hover:opacity-40 transition-opacity duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent pointer-events-none" />
                    </div>

                    {/* Content */}
                    <div className="relative z-10 h-full flex flex-col justify-between p-6 md:p-8 w-full">
                      {/* Top Content */}
                      <div>
                        <motion.h2
                          className={`text-4xl md:text-5xl font-serif font-light ${brand.textColor} mb-3`}
                          initial={{ opacity: 0, x: -20 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ delay: 0.5, duration: 0.6 }}
                        >
                          {brand.title}
                        </motion.h2>
                        <motion.p
                          className={`text-lg ${brand.textColor}/80 mb-6`}
                          initial={{ opacity: 0, x: -20 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ delay: 0.7, duration: 0.6 }}
                        >
                          {brand.subtitle}
                        </motion.p>
                        <motion.p
                          className={`${brand.textColor}/70 text-sm leading-relaxed max-w-md`}
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          transition={{ delay: 0.9, duration: 0.6 }}
                        >
                          {brand.description}
                        </motion.p>
                      </div>

                      {/* Bottom Content */}
                      <div>
                        {/* Social Links - Show when hovered */}
                        <motion.div
                          className="mb-6 space-y-3"
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ 
                            opacity: selectedBrand === brand.id ? 1 : 0,
                            y: selectedBrand === brand.id ? 0 : 20
                          }}
                          transition={{ duration: 0.3 }}
                        >
                          <a
                            href={brand.instagram}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`flex items-center space-x-2 ${brand.textColor}/80 hover:${brand.textColor} transition-colors duration-200`}
                          >
                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                            </svg>
                            <span className="text-sm">@{brand.id}</span>
                          </a>
                          <a
                            href={`mailto:${brand.email}`}
                            className={`flex items-center space-x-2 ${brand.textColor}/80 hover:${brand.textColor} transition-colors duration-200`}
                          >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                            <span className="text-sm">{brand.email}</span>
                          </a>
                        </motion.div>

                        {/* CTA Button */}
                        <Link to={brand.link}>
                          <motion.button
                            className={`w-full ${brand.buttonColor} text-white py-4 px-6 font-medium tracking-wide uppercase transition-all duration-300 hover:shadow-lg transform hover:-translate-y-1`}
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                          >
                            Explore Collection
                          </motion.button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>
      </div>

      {/* Floating Elements - Hidden on mobile to prevent overflow */}
      <div className="hidden md:block absolute top-20 left-10 w-20 h-20 bg-gold/10 rounded-full blur-xl pointer-events-none" />
      <div className="hidden md:block absolute bottom-20 right-10 w-32 h-32 bg-sage/10 rounded-full blur-xl pointer-events-none" />
    </div>

    {/* Featured Collections Section */}
    <section className="py-20 bg-white">
      <div className="section-padding">
        <div className="container-max">
          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-4xl md:text-5xl font-serif font-light text-deep-brown mb-6">
              Featured Collections
            </h2>
            <p className="text-xl text-warm-gray max-w-2xl mx-auto">
              Discover our handpicked selections that embody the essence of timeless elegance
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                title: "Festive Elegance",
                description: "Celebrate special moments with our exquisite festive collection",
                image: imgFeat1,
                category: "Indian Wear",
                link: "/indian-wear"
              },
              {
                title: "Contemporary Chic",
                description: "Modern designs for the contemporary woman",
                image: imgFeat2,
                category: "Western Wear",
                link: "/western-wear"
              },
              {
                title: "Bridal Couture",
                description: "Make your special day unforgettable",
                image: imgFeat3,
                category: "Bridal",
                link: "/indian-wear"
              }
            ].map((collection, index) => (
              <motion.div
                key={collection.title}
                className="group cursor-pointer"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                whileHover={{ y: -10 }}
              >
                <div className="relative overflow-hidden rounded-lg shadow-lg group-hover:shadow-xl transition-all duration-500">
                  <div className="relative aspect-[4/3]">
                    <img src={collection.image} alt={collection.title} className="absolute inset-0 w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
                    <div className="absolute top-4 left-4">
                      <span className="px-3 py-1 text-xs tracking-wide uppercase bg-white/80 backdrop-blur-sm text-deep-brown rounded-full">
                        {collection.category}
                      </span>
                    </div>
                    <div className="absolute bottom-4 left-4 right-4">
                      <h3 className="text-2xl font-serif font-light text-white drop-shadow mb-1">{collection.title}</h3>
                      <p className="text-white/90 text-sm leading-relaxed mb-3 line-clamp-2">{collection.description}</p>
                      <Link to={collection.link} className="inline-flex items-center text-white/90 hover:text-white transition-colors duration-300 text-sm font-medium">
                        Explore Collection
                        <svg className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                      </Link>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>

    {/* Second Video Section */}
    <section className="relative w-full h-[70vh] overflow-hidden bg-black">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src={video2} type="video/mp4" />
      </video>
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent" />
      <div className="relative z-10 h-full flex items-center section-padding">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-2xl"
        >
          <h2 className="text-4xl md:text-6xl font-serif font-light text-white mb-6">
            The Art of Fashion
          </h2>
          <p className="text-lg md:text-xl text-white/90 mb-8 leading-relaxed">
            Experience the perfect blend of traditional craftsmanship and contemporary design
          </p>
          <Link to="/about">
            <motion.button
              className="bg-white text-deep-brown px-8 py-4 font-medium tracking-wide uppercase hover:bg-cream transition-all duration-300"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Our Story
            </motion.button>
          </Link>
        </motion.div>
      </div>
    </section>

    {/* Brand Story Section */}
    <section className="py-20 bg-white">
      <div className="section-padding">
        <div className="container-max">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <h2 className="text-4xl md:text-5xl font-serif font-light text-deep-brown mb-6">
                Our Heritage
              </h2>
              <p className="text-warm-gray leading-relaxed mb-6">
                House of Deepak was born from a vision to create clothing that honors tradition while embracing modernity. 
                Each piece in our collection tells a story of craftsmanship, heritage, and contemporary elegance.
              </p>
              <p className="text-warm-gray leading-relaxed mb-8">
                From our traditional Indian wear that celebrates cultural richness to our western collection that defines 
                modern sophistication, we curate fashion that empowers and inspires.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/about">
                  <motion.button
                    className="btn-secondary"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    Our Story
                  </motion.button>
                </Link>
                <Link to="/contact">
                  <motion.button
                    className="btn-primary"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    Get in Touch
                  </motion.button>
                </Link>
              </div>
            </motion.div>

            <motion.div
              className="relative"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-4">
                  <img src={imgGallery1} alt="Heritage" className="w-full h-64 object-cover rounded-lg shadow-lg" />
                  <img src={imgGallery3} alt="Craftsmanship" className="w-full h-48 object-cover rounded-lg shadow-lg" />
                </div>
                <div className="space-y-4 mt-8">
                  <img src={imgGallery2} alt="Tradition" className="w-full h-48 object-cover rounded-lg shadow-lg" />
                  <img src={imgGallery4} alt="Elegance" className="w-full h-64 object-cover rounded-lg shadow-lg" />
                </div>
              </div>
              {/* Decorative elements - Hidden on mobile to prevent overflow */}
              <div className="hidden md:block absolute -top-6 -right-6 w-12 h-12 bg-gold/20 rounded-full blur-lg pointer-events-none" />
              <div className="hidden md:block absolute -bottom-6 -left-6 w-16 h-16 bg-sage/20 rounded-full blur-lg pointer-events-none" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>

    {/* Values Section */}
    <section className="py-20 bg-gradient-to-br from-cream to-warm-gray/5">
      <div className="section-padding">
        <div className="container-max">
          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-4xl md:text-5xl font-serif font-light text-deep-brown mb-6">
              Why Choose Us
            </h2>
            <p className="text-xl text-warm-gray max-w-2xl mx-auto">
              We're committed to delivering excellence in every aspect of your fashion journey
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: (
                  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                  </svg>
                ),
                title: "Premium Quality",
                description: "Finest fabrics and superior craftsmanship in every piece"
              },
              {
                icon: (
                  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                ),
                title: "Fast Delivery",
                description: "Quick and secure delivery across India"
              },
              {
                icon: (
                  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                  </svg>
                ),
                title: "Customer Love",
                description: "Dedicated support and personalized service"
              },
              {
                icon: (
                  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                ),
                title: "Secure Shopping",
                description: "Safe and secure payment options"
              }
            ].map((value, index) => (
              <motion.div
                key={value.title}
                className="text-center group"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <div className="w-16 h-16 bg-deep-brown/10 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-deep-brown/20 transition-colors duration-300">
                  <div className="text-deep-brown group-hover:scale-110 transition-transform duration-300">
                    {value.icon}
                  </div>
                </div>
                <h3 className="text-lg font-medium text-deep-brown mb-2">{value.title}</h3>
                <p className="text-warm-gray text-sm leading-relaxed">{value.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>

    {/* Testimonials Section */}
    <section className="py-20 bg-white">
      <div className="section-padding">
        <div className="container-max">
          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-4xl md:text-5xl font-serif font-light text-deep-brown mb-6">
              What Our Customers Say
            </h2>
            <p className="text-xl text-warm-gray max-w-2xl mx-auto">
              Hear from the fashion enthusiasts who trust House of Deepak
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                name: "Priya Sharma",
                location: "Mumbai",
                rating: 5,
                review: "Absolutely love the quality and design! The attention to detail is remarkable. My go-to place for ethnic wear.",
                product: "Festive Lehenga"
              },
              {
                name: "Anita Reddy",
                location: "Bangalore",
                rating: 5,
                review: "The western wear collection is stunning. Perfect fit and excellent fabric quality. Highly recommended!",
                product: "Contemporary Dress"
              },
              {
                name: "Kavya Patel",
                location: "Delhi",
                rating: 5,
                review: "Amazing customer service and beautiful designs. The delivery was super fast. Will definitely shop again!",
                product: "Designer Kurta Set"
              }
            ].map((testimonial, index) => (
              <motion.div
                key={testimonial.name}
                className="bg-gradient-to-br from-cream to-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-shadow duration-300"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
              >
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <svg key={i} className="w-5 h-5 text-gold fill-current" viewBox="0 0 24 24">
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                    </svg>
                  ))}
                </div>
                <p className="text-warm-gray italic mb-4 leading-relaxed">"{testimonial.review}"</p>
                <div className="flex items-center justify-between">
                  <div>
                    <h4 className="font-medium text-deep-brown">{testimonial.name}</h4>
                    <p className="text-warm-gray text-sm">{testimonial.location}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-deep-brown text-sm font-medium">{testimonial.product}</p>
                    <p className="text-warm-gray text-xs">Verified Purchase</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default Homepage;